"use client";

import React from "react";
import { Button } from "../common/button";

export interface CTAWithPreviewProps {
  title: string;
  subtitle?: string;
  ctaText: string;
  onCtaClick?: () => void;
  preview?: {
    type: "avatars" | "custom";
    avatarCount?: number;
    customContent?: React.ReactNode;
  };
  bgPattern?: boolean;
}

export function CTAWithPreview({
  title,
  subtitle,
  ctaText,
  onCtaClick,
  preview,
  bgPattern = true
}: CTAWithPreviewProps) {
  return (
    <section className="py-16 md:py-20 relative overflow-hidden">
      {/* Background pattern */}
      {bgPattern && (
        <div className="absolute inset-0 bg-gradient-to-r from-primary-50 to-secondary-50 opacity-50"></div>
      )}
      
      <div className="relative max-w-4xl mx-auto px-4 text-center">
        <div className="bg-white rounded-3xl shadow-xl p-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            {title}
          </h2>
          {subtitle && (
            <p className="text-xl text-gray-700 mb-8 max-w-2xl mx-auto">
              {subtitle}
            </p>
          )}
          
          {/* Preview */}
          {preview && (
            <div className="mb-8">
              {preview.type === "avatars" && (
                <div className="flex justify-center gap-4">
                  {[...Array(3)].map((_, i) => (
                    <div key={i} className="w-16 h-16 rounded-full bg-gray-200 border-4 border-white shadow-md"></div>
                  ))}
                  <div className="w-16 h-16 rounded-full bg-primary-100 border-4 border-white shadow-md -ml-4 flex items-center justify-center">
                    <span className="text-primary-600 font-semibold text-sm">{preview.avatarCount || "50"}+</span>
                  </div>
                </div>
              )}
              {preview.type === "custom" && preview.customContent}
            </div>
          )}
          
          <Button variant="primary" size="lg" className="min-w-[200px] shadow-lg" onClick={onCtaClick}>
            {ctaText}
          </Button>
        </div>
      </div>
    </section>
  );
}